import { launchCookieConsent } from 'lib/cookie-consent';

export const footerNavContent = [
  {
    id: 'products',
    label: 'Products',
    subNavLists: [
      {
        label: 'Shop All',
        url: '/products',
      },
    ],
  },
  {
    id: 'about',
    label: 'About',
    subNavLists: [
      {
        label: 'Science',
        url: '/approach',
      },
      {
        label: 'Sustainability',
        url: '/sustainability',
      },
      {
        label: 'SeedLabs',
        url: '/seedlabs',
      },
    ],
  },
  {
    id: 'inquire',
    label: 'Inquire',
    subNavLists: [
      {
        label: 'Superfiliate',
        url: 'https://seed.superfiliate.com/portal/sign-up',
      },
      {
        label: 'Partner',
        url: 'https://app.impact.com/campaign-promo-signup/Seed-Health-Inc.brand?execution=e1s1#/?viewkey=signUpPreStart',
      },
      {
        label: 'Practitioners',
        url: '/practitioners',
      },
      {
        label: 'Press',
        url: '/press',
      },
      {
        label: 'Careers',
        url: '/join-us',
      },
    ],
  },
  {
    id: 'help',
    label: 'Help',
    subNavLists: [
      {
        label: 'Help',
        url: 'https://help.seed.com/',
      },
      {
        label: 'Contact',
        url: 'https://help.seed.com/en-US/contact',
      },
      {
        label: 'My Account',
        url: '/account/home',
      },
      {
        label: 'International',
        url: '/entire-world',
      },
    ],
  },
  {
    id: 'social',
    label: 'Social',
    subNavLists: [
      {
        label: 'Instagram',
        url: 'https://www.instagram.com/seed',
      },
      {
        label: 'Twitter',
        url: 'https://twitter.com/seedhealth',
      },
      {
        label: 'Linkedin',
        url: 'https://www.linkedin.com/company/seedhealth',
      },
      {
        label: 'Refer',
        url: '/account/refer?traffic_source=footer_referafriend',
      },
    ],
  },
  {
    id: 'legal',
    label: 'Legal',
    subNavLists: [
      {
        label: 'Terms + Conditions',
        url: '/terms-conditions',
      },
      {
        label: 'Privacy Policy',
        url: '/privacy-policy',
      },
      {
        label: 'Accessibility',
        url: '/accessibility',
      },
      {
        label: 'Consent Preferences',
        url: '#',
        action: () => {
          launchCookieConsent();
        },
      },
    ],
  },
];
